
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"그룹 1849","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"패스 1172","d":"M0 0h20v20H0z","fill":"none"}}),_c('path',{attrs:{"data-name":"패스 1173","d":"M9.167 15h1.667v-1.666H9.167zM10 1.667A8.333 8.333 0 1018.333 10 8.336 8.336 0 0010 1.667zm0 15A6.667 6.667 0 1116.667 10 6.676 6.676 0 0110 16.667zM10 5a3.332 3.332 0 00-3.333 3.334h1.667a1.667 1.667 0 013.333 0c0 1.667-2.5 1.458-2.5 4.167h1.667c0-1.875 2.5-2.083 2.5-4.167A3.332 3.332 0 0010 5z","fill":"#727272"}})])
          )
        }
      }
    